import React, { ReactNode, createContext, useContext } from 'react';

// * Commercial Types.
// *
// * RECRUITMENT - for recruitment
// * MANAGEMENT - for management
// *
export enum CommercialType {
  RECRUITMENT = 'recruitment',
  MANAGEMENT = 'management',
}

export const COMMERCIAL_TYPES = [
  CommercialType.RECRUITMENT,
  CommercialType.MANAGEMENT,
];

export type TCommercialTypeCtx = {
  commercialType: CommercialType;
  isValidCommercialType: boolean;
};

export const CommercialTypeCtx = createContext<TCommercialTypeCtx | null>(null);

export const CommercialTypeCtxProvider = ({
  commercialType,
  children,
}: {
  commercialType: CommercialType;
  children: ReactNode;
}) => {
  const isValidCommercialType = COMMERCIAL_TYPES.includes(commercialType);

  return (
    <CommercialTypeCtx.Provider
      value={{ commercialType, isValidCommercialType }}
    >
      {children}
    </CommercialTypeCtx.Provider>
  );
};

export const useCommercialTypeCtx = (): TCommercialTypeCtx => {
  const ctx = useContext(CommercialTypeCtx);

  if (!ctx) {
    throw new Error(
      'useCommercialTypeCtx must be used within a CommercialTypeCtx'
    );
  }

  return ctx;
};
